// src/services/requestService.js
import { apiService } from './api';

export const requestService = {


  // Pour l'admin seulement
  async getAdminRequests(status = null, offerId = null) {
    let url = '/requests/admin';
    const params = new URLSearchParams();
    
    if (status) params.append('status', status);
    if (offerId) params.append('offerId', offerId);
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    const response = await apiService.get(url);
    return response.data;
  },

  async updateRequestStatus(requestId, status, notes = '') {
    const response = await apiService.put(`/requests/admin/${requestId}`, {
      status,
      notes
    });
    return response.data;
  },

  async approveRequest(requestId, notes = '') {
    return this.updateRequestStatus(requestId, 'approved', notes);
  },

  async rejectRequest(requestId, notes = '') {
    return this.updateRequestStatus(requestId, 'rejected', notes);
  }
};